/* eslint-disable */

import { processEnv } from "./env";

// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsconfig = {
    "aws_project_region": processEnv.REACT_APP_REGION,
    Auth: {

        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: processEnv.REACT_APP_IDENTITY_POOL_ID,

        // REQUIRED - Amazon Cognito Region
        region: processEnv.REACT_APP_REGION,

        // OPTIONAL - Amazon Cognito Federated Identity Pool Region
        // Required only if it's different from Amazon Cognito Region
        //identityPoolRegion: 'XX-XXXX-X',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: processEnv.REACT_APP_AWS_COGNITO_USER_POOL_ID,

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: processEnv.REACT_APP_AWS_COGNITO_CLIENT_ID,

        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not

        // OPTIONAL - Configuration for cookie storage
        // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol


        // OPTIONAL - customized storage object

        // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
        //authenticationFlowType: 'USER_PASSWORD_AUTH',

        // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
       // clientMetadata: { myCustomKey: 'myCustomValue' },

        // OPTIONAL - Hosted UI configuration
        oauth: {
            domain: processEnv.REACT_APP_COGNITO_AUTH_DOMAIN,
            scope: ['phone', 'email', 'profile', 'openid'],
            redirectSignIn:  processEnv.REACT_APP_REDIRECT_SIGNIN,
            redirectSignOut: processEnv.REACT_APP_REDIRECT_SIGNOUT,
            responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
        

    },
    Storage: {
        AWSS3: {
            bucket: processEnv.REACT_APP_S3_BUCKET,
            region: processEnv.REACT_APP_REGION,
            folder: processEnv.REACT_APP_S3_FOLDER
        }
    }
    
};


export default awsconfig;
